import { render, staticRenderFns } from "./Nvs.vue?vue&type=template&id=2d3f4f4d&scoped=true&"
import script from "./Nvs.vue?vue&type=script&lang=js&"
export * from "./Nvs.vue?vue&type=script&lang=js&"
import style0 from "./Nvs.vue?vue&type=style&index=0&id=2d3f4f4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f4f4d",
  null
  
)

export default component.exports